import React from 'react'
import Carousel from 'react-bootstrap/Carousel';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import vbanner from '../assets/vbanner.png'
import vbanner1 from '../assets/vbanner1.png'
import vbanner2 from '../assets/vbanner2.png'
import vbanner3 from '../assets/vbanner3.png'
import janma from '../assets/janmashtamiflyer.jpeg'

function Home() {
  return (
    <>
    {/*Scrollbar*/}
    <Container fluid className='px-0'>
      <Row className='mx-0'>
        <Col sm={12} className='w-100 px-0'>
          <div className='tickerwrap d-flex'>
            <div className='tickername bghead pt-3 mb-0' style={{height:50,width:150}}>
              <p className='text-white fw-bold'>Upcoming</p>
            </div>
            <div className='tickercontent bggrey1 w-100'>
            <marquee direction="left" scrolldelay="50" scrollamount="5" truespeed="" onmouseover="this.stop()" onmouseout="this.start()" behavior="scroll" height="25px">
              <ul className='tickernewsbar text-center'>

               <li className='mx-4 pt-3'><b>April 1 - Panguni Uthiram</b></li>
<li className='mx-4 pt-3'><b>April 4 - Swathi</b></li>
<li className='mx-4 pt-3'><b>April 12 - Shravana Vratam</b></li>
<li className='mx-4 pt-3'><b>April 13 - Ekadasi</b></li>
<li className='mx-4 pt-3'><b>April 14 - Dwadasi + Varsha Pirappu</b></li>
<li className='mx-4 pt-3'><b>April 15 - Pradosham / Sri Vaishnava Mounavratam (4:30–7:30pm)</b></li>
<li className='mx-4 pt-3'><b>April 17 - Amavasya + Prakrutham Sri Parakala Swami Thirunakshatram</b></li>
<li className='mx-4 pt-3'><b>April 20 - Rohini + Akshaya Tritiya</b></li>
<li className='mx-4 pt-3'><b>April 22 - Sri Ramanuja Jayanti</b></li>
<li className='mx-4 pt-3'><b>April 27 - Ekadasi</b></li>
<li className='mx-4 pt-3'><b>April 28 - Dwadasi</b></li>
<li className='mx-4 pt-3'><b>April 29 - Sri Varadaraja Perumal Avataram + Pradosham / Sri Vaishnava Mounavratam (4:30–7:30pm)</b></li>
<li className='mx-4 pt-3'><b>April 30 - Sri Nrusimha Jayanti</b></li>
                <li className='mx-4 pt-3'><b>Note : SRIMAD VALMIKI RAMAYANAM LECTURES (Every Ekadasi 8.30 pm to 9.30 pm )</b></li>
              </ul>
              </marquee>
            </div>
          </div>
        </Col>
      </Row>
    </Container>

    <Container fluid className='px-0'>
    <Carousel>
      <Carousel.Item interval={1000}>
      <img
          className="d-block  w-100"
          src={vbanner}
          alt="First slide"
        />
      </Carousel.Item>
      <Carousel.Item interval={500}>
      <img
          className="d-block  w-100"
          src={vbanner1}
          alt="Second slide"
        />
      </Carousel.Item>
      <Carousel.Item>
      <img
          className="d-block  w-100"
          src={vbanner2}
          alt="Third slide"
        />
      </Carousel.Item>
      <Carousel.Item>
      <img
          className="d-block  w-100"
          src={vbanner3}
          alt="fourth slide"
        />
      </Carousel.Item>
    </Carousel>
    </Container>
    <Container>
      <Row className='py-4'>
        <Col sm={12}>
          <h5 className='titlesec'>About</h5>
          <p className='abt'>Sri Venugopala Swamy temple is around 120 years old and is probably the oldest temple in Bolaram. The presiding deity here is Sri Rukmini Satyabhama Godhadevi sametha Sri Venugopala Swamy. Also, the presiding deity is Chaturbhuja Venugopala Swamy (Lord Krishna with 4 hands, flute and a cow) which is very unique and exclusive to the Sri Vaishnava Pancharatra tradition. The daily, fortnightly, monthly and annual rituals are being performed in maximum accordance to the Shastras and with the active participation of devotees for several decades now.
          <br/>
          <br/>
          Sri Venugopala Swamy Temple, Bolarum was built around 1902 by C.R. Subba Rao Mudaliar. Taking the legacy forward, his son C.S. Krishna Swamy Mudaliar established temple organization and strengthened the social and cultural ties of the community. The third generation kept the Temple flag flying high with visionary C.K. Kannabhiram Mudaliar and later passing on the mantle to the fourth generation.
          <br/>
          <br/>
          Currently, it is managed by CK Arjun Rao, the 4th generation trustee of the temple.
          </p>
        </Col>
      </Row>
    </Container>
    <section className='bggrey1 py-4'>
    <div className='container'>
      <div className='row pb-3'>
        <h5 className='titlesec pb-3'>Sri Venugopala Swamy Temple Trust</h5>
        <div>
        <div class="card-group">
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">President</h5>
      <p class="card-text">C.K.Arjun Rao</p>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Vice President</h5>
      <p class="card-text">S.Mohan</p>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">General Secretary</h5>
      <p class="card-text">V.S Varmesh</p>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Treasurer</h5>
      <p class="card-text">A.D Sridhar</p>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Joint Secretary</h5>
      <p class="card-text">J.B Jagadeep</p>
      <p class="card-text">V.K. Raghunath</p>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Members</h5>
      <p class="card-text">V.K Mohan Rajan</p>
      <p class="card-text">C.R.Sanjay Srivatsan</p>
      <p class="card-text">S.V. Vidya Sagar</p>
    </div>
  </div>
</div>
        </div>
      </div>
      </div>
      </section>
      <Container>
        <Row>
          <Col sm={12}>
            <h5 className='titlesec py-2'>Temple Overview</h5>
          <div className="ratio ratio-16x9">
  <iframe src="https://www.youtube.com/embed/rg6aAOU52Cw?si=NVMe_1sUlmqzagxF" title="YouTube video" allowFullScreen></iframe>
          </div>

          </Col>
        </Row>
      </Container>

      {/*Monthly changes */}
      <section className='bggrey1'>
      <Container className='py-3'>
        <Row>
          <Col sm={12}>
            <div className='card shadow-sm rounded'>
              <div className='card-body'>
                <h5 className='border-bottom pb-2 titlesec'>Events for the Month of April-2026</h5>
                <table class="table">
  <tbody>
   
    
     <tr>
      <th scope="row">April 1, 2026
      <br/>
      (Wednesday)
      </th>
      <td colspan="3">
       <strong>Panguni Uthiram</strong>
      </td>
    </tr>
    <tr>
      <th scope="row">April 4, 2026
      <br/>
      (Saturday)
      </th>
      <td colspan="3">
       <strong>Swathi</strong>
      </td>
    </tr>
     <tr>
      <th scope="row">April 12, 2026
      <br/>
      (Sunday)
      </th>
      <td colspan="3">
       <strong>Shravana Vratam</strong>
      </td>
    </tr> 

     <tr>
      <th scope="row">April 13, 2026
      <br/>
      (Monday)
      </th>
      <td colspan="3">
       <strong>Ekadasi</strong>
      </td>
    </tr>
    <tr>
      <th scope="row">April 14, 2026
      <br/>
      (Tuesday)
      </th>
      <td colspan="3">
       <strong>Dwadasi + Varsha Pirappu</strong>
      </td>
    </tr> 
    <tr>
      <th scope="row">April 15, 2026
      <br/>
      (Wednesday)
      </th>
      <td colspan="3">
       <strong>Pradosham / Sri Vaishnava Mounavratam (4:30-7.30pm)</strong>
      </td>
    </tr>
      <tr>
      <th scope="row">April 17, 2026
      <br/>
      (Friday)
      </th>
      <td colspan="3">
       <strong>Amavasya + Prakrutham Sri Parakala Swami Thirunakshatram</strong>
      </td>
    </tr>
    <tr>
      <th scope="row">April 20, 2026
      <br/>
      (Monday)
      </th>
      <td colspan="3">
       <strong>Rohini + Akshaya Tritiya</strong>
      </td>
    </tr>
     <tr>
      <th scope="row">April 22, 2026
      <br/>
      (Wednesday)
      </th>
      <td colspan="3">
       <strong>Sri Ramanuja Jayanti</strong>
      </td>
    </tr>
     <tr>
      <th scope="row">April 27, 2026
      <br/>
      (Monday)
      </th>
      <td colspan="3">
       <strong>Ekadasi</strong>
      </td>
    </tr>
     <tr>
      <th scope="row">April 28, 2026
      <br/>
      (Tuesday)
      </th>
      <td colspan="3">
       <strong>Dwadasi</strong>
      </td>
    </tr>
     <tr>
      <th scope="row">April 29, 2026
      <br/>
      (Wednesday)
      </th>
      <td colspan="3">
       <strong>Sri Varadaraja Perumal Avataram + Pradosham / Sri Vaishnava Mounavratam (4:30-7.30pm)</strong>
      </td>
    </tr>
    <tr>
      <th scope="row">April 30, 2026
      <br/>
      (Thursday)
      </th>
      <td colspan="3">
       <strong>Sri Nrusimha Jayanti</strong>
      </td>
    </tr>





    {/* <tr className='text-center fw-bold'>
    <td>
    <div className='text-center' style={{color:' #3465aa'}}>Special Days to Note:</div>
    </td>
    <td>&nbsp;</td>
    </tr>
    <tr>
      <th scope="row">5th November 2025
      <br/>
      (Wednesday)
      </th>
      <td colspan="3">
       <strong> Chandramana Karthika Pournami </strong>
      </td>
    </tr> 
    <tr>
      <th scope="row">16th November, 2025
      <br/>
      (Sunday)
      </th>
      <td colspan="3">
       <strong>Vrischika Sankramanam (Karthigai masam begins)</strong>
      </td>
    </tr>  */}
    {/* <tr>
      <th scope="row">7th July, 2025
      <br/>
      (Monday)
      </th>
      <td colspan="3">
       <strong> (Anni- Anusham) Sri NATHAMUNIGAL</strong>
      </td>
    </tr>  */}
    {/* <tr>
      <th scope="row">3rd  &  17th November, 2025
      <br/>
      (Friday)
      </th>
      <td colspan="3">
       <strong>Pradosham - Sri Vaishnava Mouna Vartham (4.30 Pm to 7.30 Pm)</strong>
      </td>
    </tr> 
    
     <tr>
      <th scope="row">19th November, 2025
      <br/>
      (Wednesday)
      </th>
      <td colspan="3">
       <strong>AMAVASYA</strong>
      </td>
    </tr>  
    <tr>
      <th scope="row">26th November, 2025
      <br/>
      (Wednesday)
      </th>
      <td colspan="3">
       <strong> Shravana Vratam</strong>
      </td>
    </tr>  */}
    
    
    
  </tbody>
                </table>
                {/* <img src={janma} style={{width:'400px',height:'500px'}} /> */}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
     </section>




<section className='bggrey1'>
      <Container className='py-3'>
        <Row>
          <Col sm={12}>
            <div className='card shadow-sm rounded'>
              <div className='card-body'>
                <h5 className='border-bottom pb-2 titlesec'>Event Calendar for the Year 2026</h5>
                <table class="table">
  <tbody>
    {/* <tr>
      <th scope="row" >10th January, 2025
      <br/>
      (Friday)
      </th>
      <td colspan="3">
      <strong>
       Vaikunta Ekadasi
      </strong> 
      </td>
    </tr>
    
    <tr>
      <th scope="row">11th January, 2025
      <br/>
      (Saturday)
      </th>
      <td colspan="3">
      <strong>Kudaarai Paayasam</strong>
      </td>
    </tr> */}


    <tr>
      <th scope="row">14th January, 2026

      </th>
      <td colspan="3">
    <strong>Pongal (Andal Kalyanam)</strong> 
      </td>
    </tr>
    <tr>
      <th scope="row">19th March, 2026
      </th>
      <td colspan="3">
       <strong>Ugadi</strong>
      </td>
    </tr>
    <tr>
      <th scope="row">27th March, 2026
      </th>
      <td colspan="3">
       <strong>Sri Rama Navami</strong>
      </td>
    </tr>
    <tr>
      <th scope="row">14th April, 2026
      </th>
      <td colspan="3">
       <strong>Tamil Putthaandu</strong>
      </td>
    </tr>
    <tr>
      <th scope="row">19th April, 2026
      </th>
      <td colspan="3">
       <strong>Akshaya Tritiya</strong>
      </td>
    </tr>
    <tr>
      <th scope="row">22nd April, 2026
      </th>
      <td colspan="3">
       <strong>Sri Ramanuja Jayanthi</strong>
      </td>
    </tr>
    <tr>
      <th scope="row">30th April, 2026
      </th>
      <td colspan="3">
       <strong>Sri Nrusimha Jayanthi</strong>
      </td>
    </tr>
    <tr>
      <th scope="row">25th July, 2026
      </th>
      <td colspan="3">
       <strong>Tholi Ekadasi</strong>
      </td>
    </tr>
    <tr>
      <th scope="row">14th August, 2026
      </th>
      <td colspan="3">
       <strong>Sri Andal Thiruvaadipooram</strong>
      </td>
    </tr>
     <tr>
      <th scope="row">4th September, 2026
      </th>
      <td colspan="3">
       <strong>Sri Krishna Janmashtami + Sri Jayanthi</strong>
      </td>
    </tr>
    <tr>
      <th scope="row">23rd September, 2026
      </th>
      <td colspan="3">
       <strong>Sri Vedanta Desikan</strong>
      </td>
    </tr>
    <tr>
      <th scope="row">20th October, 2026
      </th>
      <td colspan="3">
       <strong>Vijaya Dashami</strong>
      </td>
    </tr>
    <tr>
      <th scope="row">6th November, 2026
      </th>
      <td colspan="3">
       <strong>Dhana Trayodashi</strong>
      </td>
    </tr> 
       <tr>
      <th scope="row">8th November, 2026
      </th>
      <td colspan="3">
       <strong>Deepavali</strong>
      </td>
    </tr> 
      <tr>
      <th scope="row">24th November, 2026
      </th>
      <td colspan="3">
       <strong>Kartika Pournami + Pancharatra Deepam</strong>
      </td>
    </tr> 
    <tr>
      <th scope="row">16th December, 2026
      </th>
      <td colspan="3">
       <strong>Margazhi Begins</strong>
      </td>
    </tr> 
    <tr>
      <th scope="row">20th December, 2026
      </th>
      <td colspan="3">
       <strong>Vaikunta Ekadasi</strong>
      </td>
    </tr> 
  
    
  </tbody>
</table>

              </div>
            </div>
          </Col>
        </Row>
      </Container>
</section>
    </>
  )
}

export default Home